import { render, staticRenderFns } from "./TemplatePriceList.vue?vue&type=template&id=1db09f95&"
import script from "./TemplatePriceList.vue?vue&type=script&lang=js&"
export * from "./TemplatePriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports